import axios from "state/axios";

async function UserAuth() {
  try {
    const res = await axios.get('employee/check');
    
    if (res.status === 200) {       
      return true;
      
    } else {
      return false;
    }
  } catch (error) {

  }
}

async function UserSubscription() {
  try {
    const res = await axios.get('myauth/plan/refresh');
    if (res.status === 200) {       
      return true;
      
    } else {
      return false;
    }
  } catch (error) {

  }
}

async function AdminAuth() {
  try {
    const res = await axios.get('usrauth');  
    if (res.status === 200) {
      return true;
    
    } else {
      return false;
    }

  } catch (error) {
    return false;
  }
}

async function CombinedAuth() {
  let usrLog = false;
  let admLog = false;
  
  try {
    usrLog = await UserAuth();
    
    if (usrLog) {
      admLog = await AdminAuth();
      console.log(admLog);
    }
    
    if (usrLog && admLog) {
      return {user:true, adm:true};
    
    } else if (usrLog && !admLog) {
      return {user:true, adm:false}
    
    } else {
      return {user:false, adm:false};
    }
  } catch (error) {

  }
}

export { UserAuth, AdminAuth, CombinedAuth, UserSubscription };
